// Textures取得の際、1日前、２日前、３日前、１週間前、1ヶ月前（３０日換算）、半年前（３０日*6）、１年前（30日*12）まで試し、limitまでの取得を目指す。
export const TEXTURE_GET_HOUR_RANGE = [24, 48, 72, 168, 720, 4320, 8640];

// Textures取得の際、何件まで取得するかの値
export const TEXTURE_GET_LIMIT = 100;

// 花束API設定
export const BOUQUETS_TIMEOUT_MINUTES = 3;
